import { ISale, ISaleData, Sale } from "@/entities";
import { ISaleRepository } from "./sale.types";
import { API, graphqlOperation } from "aws-amplify";
import * as queries from "@/graphql/queries";
import * as customQueries from "@/customGraphql/queires";
import * as mutations from "@/graphql/mutations";
import { CreateSaleMutation, GetSaleQuery, UpdateSaleMutation } from "@/API";

export class SaleAPIRepository implements ISaleRepository {
    async get(id: string): Promise<ISale | undefined> {
        const result = (await API.graphql({
            ...graphqlOperation(customQueries.getSaleWithCustomer, {
                id,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;

        console.log({ result });

        const u = (result?.data as GetSaleQuery).getSale;
        const user: any = u;

        if (u) {
            // if (u.bots) {
            //     user.bots = u.bots.items;
            // }
            return new Sale(user);
        }
        return;
    }

    async create(data: ISaleData): Promise<ISale> {
        const result = (await API.graphql({
            ...graphqlOperation(mutations.createSale, {
                input: data,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;
        const u = (result?.data as CreateSaleMutation).createSale;
        const user: any = u;
        // if (u?.bots) {
        //     user.bots = u.bots.items;
        // }
        return new Sale(user as any);
    }

    async update(data: ISaleData): Promise<ISale> {
        const result = (await API.graphql({
            ...graphqlOperation(mutations.updateSale, {
                input: data,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        })) as any;
        const u = (result?.data as UpdateSaleMutation).updateSale;
        const user: any = u;
        // if (u?.bots) {
        //     user.bots = u.bots.items;
        // }
        return new Sale(user as any);
    }

    async delete(id: string): Promise<void> {
        await API.graphql({
            ...graphqlOperation(mutations.updateSale, {
                id,
            }),
            ...{
                authMode: "AMAZON_COGNITO_USER_POOLS",
            },
        });
        return;
    }
}
